import React, { useState } from 'react';
import { QuestRoute } from './api/QuestRoutes';
import Img from './Img';
import Loader from './Loader';

const CompanyLogo = ({ text = false, ...props }) => {

    const [logo, setLogo] = useState(null)

    return (
        <Loader
            route={QuestRoute.settings.logo}
            setData={setLogo}
        >
            <Img dim={props.dim || 6} src={'data:image/png;base64,' + logo?.logoLarge} />
        </Loader>
    );
}

export default CompanyLogo;
